import React, { useState } from 'react';
import axios from 'axios';
import API from '../api';
import { useNavigate } from 'react-router-dom';



export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();

  // Selalu ubah permissions menjadi array
  const normalizePerms = (raw) => {
    try {
      if (raw == null) return [];
      if (Array.isArray(raw)) return raw;
      if (typeof raw === 'string' && raw.trim()) return JSON.parse(raw);
      if (typeof raw === 'object') return JSON.parse(JSON.stringify(raw));
    } catch (e) {
      console.warn('Gagal parse permissions:', raw, e);
    }
    return [];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setLoading(true);
    try {
    const { data } = await API.post('/auth/login', { username, password });
      const userData = {
        ...data,
        permissions: normalizePerms(data.permissions),
      };

      console.log('LOGIN DATA (after normalize):', userData);

      
      onLogin?.(userData);
                    
// simpan user
// simpan user (persist saat refresh)
localStorage.setItem("user", JSON.stringify(userData));

// simpan token juga
const t = String(userData.token || "").trim();
localStorage.setItem("token", t);

// (opsional) hapus jejak sessionStorage biar tidak bentrok
try {
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("token");
} catch {}

// navigate
navigate("/");
    } catch (error) {
      console.error('Login error:', error);
      const msg = error.response?.data || 'Terjadi kesalahan';
      setErrorMsg(typeof msg === 'string' ? msg : 'Login gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="login-page"
      style={{
        backgroundImage: "url('/img/bag-sip.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '150vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 16,
      }}
    >
      <div
        className="card"
        style={{
          width: 380,
          padding: 24,
          background: 'linear-gradient(135deg, rgba(255,255,255,0.35), rgba(255,255,255,0.15))',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          border: '1px solid rgba(255,255,255,0.35)',
          borderRadius: 16,
          boxShadow: '0 12px 28px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.35)',
        }}
      >
        {/* Logo */}
        <div className="text-center" style={{ position: 'relative', marginBottom: 10 }}>
          <div
            aria-hidden
            style={{
              position: 'absolute',
              inset: 0,
              margin: 'auto',
              width: 210,
              height: 210,
              borderRadius: '50%',
              background: 'radial-gradient(closest-side, rgba(255,255,255,0.7), rgba(255,255,255,0) 70%)',
              filter: 'blur(8px)',
            }}
          />
          <img
            src="/IMG/IT logo.jpg"
            alt="Logo"
            style={{
              width: 220,
              height: 220,
              objectFit: 'contain',
              position: 'relative',
              filter: 'drop-shadow(0 10px 14px rgba(0,0,0,0.28)) saturate(1.05) contrast(1.02)',
            }}
          />
        </div>

        <form onSubmit={handleSubmit} className="card-body" style={{ padding: 0 }}>
          {errorMsg && <div className="alert alert-danger py-2">{errorMsg}</div>}
          <div className="form-group mb-3">
            <input
              value={username}
              onChange={e => setUsername(e.target.value)}
              className="form-control"
              placeholder="Username"
              required
              autoFocus
              disabled={loading}
              style={{
                background: 'rgba(255,255,255,0.85)',
                border: '1px solid rgba(0,0,0,0.08)',
                borderRadius: 10,
              }}
            />
          </div>
          <div className="form-group mb-3">
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="form-control"
              placeholder="Password"
              required
              disabled={loading}
              style={{
                background: 'rgba(255,255,255,0.85)',
                border: '1px solid rgba(0,0,0,0.08)',
                borderRadius: 10,
              }}
            />
          </div>
          <div className="form-group text-center">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              style={{ width: '100%', borderRadius: 10, boxShadow: '0 8px 16px rgba(44,123,229,0.35)' }}
            >
              {loading ? 'Memproses…' : 'Login'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
